import DevLog from '../../devlog/Module'
import errorAction from '../../../actions/error/errorAction'
import { doPost } from '../doPost'

import { IAction, IPVResponse, SurveyMode } from '../../../actions/types'
import { IErrorResponse } from '../types'
import { ModuleID } from '../../types'

import { DEBUG_CLIENT } from '../const'
import { getURLfromAction } from '../lib'
import HooksModule from '../../hooks/Module'

export default async function loadAction(fromAction: IAction) {
  const body = fromAction

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestPrevAction', body)
  }

  let loadedAction = errorAction({ ...fromAction })

  if (fromAction.action_url || fromAction.redirect_url) {
    try {
      // if (fromAction.payload?.data_values) body.data_values = fromAction.payload.data_values
      if (fromAction.payload?.mode) body.mode = fromAction.payload.mode as SurveyMode
      const response = await doPost<IAction | IPVResponse | IErrorResponse>(getURLfromAction(fromAction), body).catch(
        error => {
          DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'loadAction')
          return errorAction({ ...fromAction })
        }
      )
      if (!response) {
        DevLog.error(
          new Error('null response from loadAction'),
          `SW[${ModuleID.CLIENT}]:`,
          'loadAction',
          fromAction,
          'body',
          body
        )
        return loadedAction
      }
      loadedAction =
        'error' === (response as IErrorResponse).status
          ? errorAction({ ...fromAction })
          : (response as IAction).action
          ? (response as IAction)
          : (response as IPVResponse).data
      if (!loadedAction.mode) {
        loadedAction.mode = fromAction.mode
          ? fromAction.mode
          : body?.mode && Object.values(SurveyMode).includes(body.mode)
          ? body.mode
          : void 0
      }
      if (loadedAction.data && HooksModule.hasInterceptHook) {
        await HooksModule.doIntercept(loadedAction)
      }
      // if (!loadedAction.is_mobile) loadedAction.is_mobile = fromAction.is_mobile || fromAction.payload.is_mobile
    } catch (error) {
      DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'loadAction')
    }
  } else {
    DevLog.error(new Error('no action_url in action'), `SW[${ModuleID.CLIENT}]:`, 'loadAction', fromAction)
  }

  return loadedAction
}
